import { FunctionComponent } from 'react'
import useStyles from './styles'
import { Text } from '@conexasaude/conexa-hero'
import { PersonalDataSection } from '../PersonalDataSection'
import { EmergencyContactSection } from '../EmergencyContactSection'
import { DataEditingFormType } from './types'
import { RenderIf } from '@/components/RenderIf'
import { PregnantDataSection } from '../PregnantDataSection'

const DataEditingForm: FunctionComponent<DataEditingFormType> = ({
  sexes,
  hideHeader,
  hidePregnancyForm,
}) => {
  const styles = useStyles()

  return (
    <div>
      <RenderIf condition={!hideHeader}>
        <div css={styles.heading}>
          <Text variant="headingLarge">Atualize seus dados</Text>
          <Text variant="subheading">Todos os campos são obrigatórios.</Text>
        </div>
      </RenderIf>
      <div css={styles.content}>
        <PersonalDataSection sexes={sexes} />
        <RenderIf condition={!hidePregnancyForm}>
          <PregnantDataSection />
        </RenderIf>
        <EmergencyContactSection />
      </div>
    </div>
  )
}

export default DataEditingForm
